import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClassroomState {
  classroomId: string | null;
  classroomName: string | null;
}

// 🔹 Load from localStorage on init
const initialState: ClassroomState = {
  classroomId: localStorage.getItem("classroomId"),
  classroomName: localStorage.getItem("classroomName"),
};

const classroomSlice = createSlice({
  name: "classroom",
  initialState,
  reducers: {
    setClassroomId: (state, action: PayloadAction<string>) => {
      state.classroomId = action.payload;
      localStorage.setItem("classroomId", action.payload); // persist
    },
    clearClassroomId: (state) => {
      state.classroomId = null;
      localStorage.removeItem("classroomId"); 
    },
    setClassroomName: (state, action: PayloadAction<string>) => {
      state.classroomName = action.payload;
      localStorage.setItem("classroomName", action.payload); // persist
    },
  },
});

export const { setClassroomId, clearClassroomId, setClassroomName } =
  classroomSlice.actions;

export default classroomSlice.reducer;
